// React
import { useCallback } from 'react';

/**
 * Returns a handler for Radix's onOpenAutoFocus that scrolls the selected
 * item into view. Pass selectedValue and use the returned handler on PopoverContent.
 */
export function useScrollToSelected(selectedValue: string | undefined) {
  return useCallback((e: Event) => {
    if (!selectedValue) return;

    const content = e.currentTarget as HTMLElement;
    if (!content) return;

    const selectedEl = content.querySelector(
      `[data-value="${CSS.escape(selectedValue)}"]`,
    ) as HTMLElement | null;
    if (!selectedEl) return;

    selectedEl.scrollIntoView({ block: 'center', behavior: 'instant' });
  }, [selectedValue]);
}
